export default __webpack_public_path__ + "static/media/File No. 4.4fd29d89.pdf";